import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';
import chooseDialog from "@pages/Order/MeetOrder/components/chooseDialog/index.vue" //选择代理商
import schoolList from "../schoolList/index.vue" //园所弹窗
import AddressDialog from "../AddressDialog/index.vue" // 选择收货地址弹窗
import addClass from "../addClass/index.vue" // 创建班级
import optOpenClassDialog from '@pages/Order/components/optOpenClassDialog/index.vue'; //添加幼儿园（原开课申请）
import payTypeInfo from '@pages/Order/MeetOrder/components/payTypes/index.vue'; //支付方式

export default {
    mixins: [services],
    components: {
        chooseDialog,
        AddressDialog,
        optOpenClassDialog,
        payTypeInfo,
        addClass,
        schoolList
    },
    props: {
        value: {
            type: Boolean,
            default: null
        },
    },
    created() {


    },
    data() {
        return {
            num: 1,
            loading: false,
            agent: '',
            school: '',
            form: this.getSubmitFormData(),
            SchoolConsigneeList: [],
            ConsigneeList: '', //收货地址
            ConsigneeListName: '', //联系人及电话
            dialogVisible: false, //没有园所提示的弹窗
            AddDialogVisible: false,
            showData: this.getShowData(), //弹窗传参
            pageIndex: 1,
            pageSize: 10,
            minNum: 1,
            maxNum: Infinity,
            isDelShow: [false],
            payList: [{}],
            orderPackages: [{
                Id: 1013,
                label: "2018Q2暑期班"
            }],
            ClassLists: [],
            openClassList: [{
                ClassId: '',
                ClassLists: this.ClassLists
            }],
            totalNum: 0,
            labelName: '代理商',
            storeAgentStyle: '',
            IsAreaRole: 0,
            schoolConsignee: this.getSchoolConsignee()
        }
    },
    methods: {

        getSubmitFormData() {
            return cloneDeep({
                "ClassNum": 1,
                "ClassList": [],
                "MoreClassNum": 0,
                "OrderPrice": 0,
                "SchoolConsigneeId": 0,
                "OrderId": 0,
                "TimeStamp": 0,
                "PackageId": 1013,
                "SendMode": 221, //快递
                "PayMode": 222,
                "ListMeetPay": [],
                "GoodsList": [],
                "AgentId": 0,
                "SchoolId": 0,
                "AgentStyle": '',
                "PayObject": '',
                OrderRemark: ''
            });
        },
        // 园所地址
        getSchoolConsignee() {
            return cloneDeep({
                ConsigneeProvId: '',
                ConsigneeCityId: '',
                ConsigneeAreaId: '',
                Consignee: '',
                ConsigneeAddress: '',
                ConsigneeTel: ''
            })
        },
        getShowData() {
            return cloneDeep({
                SchoolId: 0,
                title: '',
                isReadOnly: false,
            });
        },
        //初始化数据
        initData() {
            this.form = this.getSubmitFormData()
            this.showData = this.getShowData()
            this.schoolConsignee = this.getSchoolConsignee()
            this.school = ""
            this.agent = ""
            this.ConsigneeList = ''
            this.ConsigneeListName = ''
            this.payList = [{}]
            this.loading = false
            this.ClassLists = []
            this.IsAreaRole = 0
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]
        },
        // 重置代理商信息，园所信息，收货地址
        initData2() {
            this.form.SchoolId = 0
            this.school = ""
            this.form.AgentId = 0
            this.agent = ""
            this.form.SchoolConsigneeId = 0
            this.ConsigneeList = ''
            this.ConsigneeListName = ''
            this.form.MoreClassNum = 0
            // this.form.PayObject = null
            // this.payList = [{}]
            this.loading = false
            this.form.ClassNum = 1
            this.ClassLists = []
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]
        },
        show(options) {
            this.initData();
            this.AddDialogVisible = true
            this.showData.title = options.title
            if (options.OrderId) {
                this.GetById(options.OrderId)
            }

        },
        // 选择归属方
        changeAgentStyle(val) {
            if (val !== this.storeAgentStyle) {
                // 切换修改清空代理商信息
                this.initData2()
            }
            if (val == 2) {
                this.labelName = '代理商'
            } else if (val == 1) {
                this.labelName = '业务员'
            }
        },
        changeProNum(val) {
            this.totalNum = val

        },
        // 开班数
        changeNum(val) {
            if (this.form.MoreClassNum > val) {
                this.form.MoreClassNum = val
            }

            let len = this.openClassList.length

            if (val > len) {
                this.openClassList.push({
                    ClassId: '',
                    ClassLists: this.ClassLists
                })
            } else {
                // 减
                this.openClassList.pop()
            }


        },
        // 新增支付方式
        addFn() {
            this.payList.push({})
            this.isDelShow.push(true)
        },
        // 删除支付方式
        delPayFn(item) {
            this.payList.splice((item.index - 1), 1);

        },
        // 创建班级
        addClass() {
            if (this.form.SchoolId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择园所',
                    type: 'warning'
                });
            } else {
                this.$refs.refAddClass.show({
                    title: '创建班级',
                    SchoolId: this.form.SchoolId
                })
            }

        },
        getClassList(item) {
            this.ZqwPlatform_GetClassList(this.form.SchoolId)
        },
        //添加幼儿园
        addSchool() {
            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择代理商',
                    type: 'warning'
                });
            } else {
                this.$refs.refoptOpenClassDialog.show({
                    AgentId: this.form.AgentId,
                    isAdd: true,
                    SchoolCome: 5,
                    isShowImg: false
                })
            }
        },
        getSchoolName(item) {
            //添加幼儿园后默认选中当前添加的幼儿园
            //item.SyncSchoolId存在则显示同步幼儿园后数据
            if (this.form.AgentStyle == 1) {
                // 业务员新增园所验证是否是属于所属区域的园所
                this.CheckSchoolAreaRole(item.SchoolId, this.form.AgentId)
            }
            this.$nextTick(() => {
                if (this.IsAreaRole !== 0) {
                    this.form.ClassNum = 1
                    this.ClassLists = [] //班级列表置空
                    this.form.ClassList = []
                    this.openClassList = [{
                        ClassId: '',
                        ClassLists: this.ClassLists
                    }]
                    this.school = item.SchoolName + '  ' + item.PrincipalName + '  ' + item.PhoneNo
                    this.form.SchoolId = item.SchoolId
                    this.getSchoolConsigneeList(this.form.SchoolId)
                    this.ZqwPlatform_GetClassList(this.form.SchoolId)
                } else if (this.form.AgentStyle == 1 && this.IsAreaRole == 0) {
                    this.$notify({
                        title: '警告',
                        message: '该园所不在所属业务员所属区域',
                        type: 'warning'
                    });
                }
            })


        },
        // 获取组件chooseDialog 值
        getDialogList(item) {
            // 切换代理商或园所重置资源包数据
            this.form.PayObject = null;
            this.agent = item.Customer + '   ' + item.Address + '   ' + item.AgentTel
            this.form.AgentId = item.Id
            this.school = ''
            this.form.SchoolId = 0
            this.form.ClassNum = 1
            this.ClassLists = [] //班级列表置空
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]
            this.ConsigneeList = ''
            this.ConsigneeListName = ''
            this.form.SchoolConsigneeId = 0
            if (item.HasSchool !== 1 && this.form.AgentStyle == 2) {
                this.$alert('该代理商名下没有幼儿园！', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                });
            }
        },
        // 获取园所选中的值
        getSchoolItem(item) {
            this.form.ClassNum = 1
            this.ClassLists = [] //班级列表置空
            this.form.ClassList = []
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]
            this.school = item.SchoolName + '   ' + item.PrincipalName + '   ' + item.PhoneNo
            this.form.SchoolId = item.Id

            this.getSchoolConsigneeList(this.form.SchoolId) //点击园所之后获取默认收货地址
            this.ZqwPlatform_GetClassList(this.form.SchoolId)
        },
        //获取选择弹窗收货地址
        getAddress(item) {
            this.schoolConsignee.ConsigneeProvId = item.ConsigneeProvince
            this.schoolConsignee.ConsigneeCityId = item.ConsigneeCity
            this.schoolConsignee.ConsigneeAreaId = item.ConsigneeArea
            this.schoolConsignee.ConsigneeAddress = item.ConsigneeAdress
            this.schoolConsignee.Consignee = item.Consignee
            this.schoolConsignee.ConsigneeTel = item.ConsigneeTel

            this.ConsigneeList = item.ConsigneeProvinceName + '  ' + item.ConsigneeCityName + '  ' + item.ConsigneeAreaName + '  ' + item.ConsigneeAdress
            this.ConsigneeListName = item.Consignee + '  ' + item.ConsigneeTel

        },
        // 选择代理商
        chooseAgent() {
            if (this.form.AgentStyle == '') {
                this.$notify({
                    title: '警告',
                    message: '请先选择归属方',
                    type: 'warning'
                });
                return;
            }
            this.$refs.chooseDialog.show({
                title: '选择' + this.labelName,
                isCommon: true,
                AgentStyle: this.form.AgentStyle
            });

        },
        //选择园所
        chooseSchool() {
            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择开课园所',
                    type: 'warning'
                });
            } else {
                this.$refs.refschoolList.show({
                    title: '选择园所',
                    AgentId: this.form.AgentId,
                    AgentType: this.form.AgentStyle

                });

            }

        },

        //修改园所收货地址
        changeAddress() {
            this.$nextTick(() => {
                this.$refs.AddressDialog.show({
                    SchoolId: this.form.SchoolId,
                    address: this.schoolConsignee,
                    Id: this.form.SchoolConsigneeId
                });
            })

        },
        add() {
            this.addClass()
            this.dialogVisible = false
        },
        other() {
            this.chooseSchool()
            this.dialogVisible = false

        },

        submit() {
            this.form.OrderPrice = this.price;
            this.form.GoodsList = []
            // 支付方式
            this.form.ListMeetPay = []


            // 班级列表
            this.form.ClassList = []
            for (let i = 0; i < this.form.ClassNum; i++) {
                if (this.openClassList[i].ClassId !== '') {
                    this.form.ClassList.push(this.openClassList[i].ClassId)
                }
            }
            if (this.form.MoreClassNum > 0) {
                this.form.GoodsList = [{
                    "ProId": 758,
                    "ProNum": this.packages[0].ProNum
                }]
            }
            let rule = [{
                name: "归属方",
                value: this.form.AgentStyle,
                required: true,
                msg: '请选择归属方'
            }, {
                name: "所属" + this.labelName,
                value: this.agent,
                required: true,
                msg: '请选择所属' + this.labelName
            }, {
                name: "开课园所",
                value: this.school,
                required: true,
                msg: '请选择开课园所'
            }, {
                name: "支付对象",
                value: this.form.PayObject,
                required: true,
                msg: '请选择支付对象'
            }, {
                name: "开课班级",
                value: this.form.ClassList,
                required: true,
                msg: '请选择开课班级'
            }];
            var flag = util.checkForm({
                ele: this,
                rules: rule
            });

            if (!flag) {
                return;
            }
            if (this.form.ClassList.length !== this.form.ClassNum) {
                this.$notify({
                    title: '警告',
                    message: '请选择开课班级',
                    type: 'warning'
                });
                return;
            }
            for (let i = 0; i < this.payList.length; i++) {
                // 价格为0时不需要填写支付信息
                if (this.form.OrderPrice > 0) {
                    let data = this.$refs['payInfo' + (i + 1)][0].validate();
                    if (!data) {
                        return;
                    }
                    this.form.ListMeetPay.push(data);
                } else {
                    this.form.ListMeetPay = []
                }
            }
            // 判断是否提交相同的班级
            let arr = cloneDeep(this.form.ClassList)
            var nary = arr.sort();
            for (var i = 0; i < arr.length; i++) {
                if (nary[i] == nary[i + 1]) {
                    this.$notify({
                        title: '警告',
                        message: '不能存在相同的班级',
                        type: 'warning'
                    });
                    return;

                }
            }
            if (this.form.OrderId > 0) {
                this.getUpdateOrderList()
            } else {
                this.SummerClassOrderAdd()
            }

        },

    },
    computed: {
        //资源包价格
        price() {
            let num = 0
            if (this.totalNum == 0 && this.form.MoreClassNum > 0) {
                this.totalNum = this.form.MoreClassNum * 20
            } else if (this.form.MoreClassNum == 0) {
                this.totalNum = 0
            }
            if (this.packages[0].ProNum !== this.totalNum) {
                this.totalNum = this.packages[0].ProNum
            }
            if (this.form.PayObject == 0) {
                //  园所加购班级*3500+【（总班级数-加购班级）*2500】+【（总艺术材料包数量-20*加购班级数）*70】

                num = this.form.MoreClassNum * 3500 + (this.form.ClassNum - this.form.MoreClassNum) * 2500 + (this.totalNum - 20 * this.form.MoreClassNum) * 70
            } else if (this.form.PayObject == 1) {
                //  代理商加购班级*2500+【（总班级数-加购班级）*2000】+【（总艺术材料包数量-20*加购班级数）*70】

                num = this.form.MoreClassNum * 2500 + (this.form.ClassNum - this.form.MoreClassNum) * 2000 + (this.totalNum - 20 * this.form.MoreClassNum) * 70
            }

            return num
        },
        packages() {
            return [{
                ProId: 758,
                ProName: '艺术亲子活动包',
                ProNum: 20 * this.form.MoreClassNum
            }]
        },
        courses() {
            // 课程
            if (this.form.MoreClassNum > 0) {
                return [{
                    ProName: '英语寒暑课',
                    ProNum: 12 * this.form.ClassNum
                }, {
                    ProName: '艺术亲子活动课',
                    ProNum: 2 * this.form.MoreClassNum
                }]
            } else {
                return [{
                    ProName: '英语寒暑课',
                    ProNum: 12 * this.form.ClassNum
                }]
            }

        },

    },
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/addSummerSchoolOrder/vm.js